import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Image from 'components/Image';
import MediaMdUp from 'components/Responsive/MediaMdUp';

export default function DisplayQualityMdUp({
  effectiveLevel, isChanging, image, name, nameAndLevel, nature, onClick, tooltipData,
}) {
  return (
    <MediaMdUp>
      <div className={classnames(
        'display-quality__image-and-name',
        isChanging && 'display-quality--is-changing',
      )}
      >
        <div
          className={classnames(
            'icon',
            nature === 'Status' && 'icon--circular',
            'display-quality__image',
          )}
        >
          <Image
            icon={image}
            alt={name}
            type="small-icon"
            onClick={onClick}
            tooltipData={tooltipData}
          />
          <span className="icon__value">{effectiveLevel}</span>
        </div>
        <div>
          <span className="js-item-name item__name">
            {nameAndLevel}
          </span>
        </div>
      </div>
    </MediaMdUp>
  );
}

DisplayQualityMdUp.propTypes = {
  effectiveLevel: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  isChanging: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  nameAndLevel: PropTypes.string.isRequired,
  nature: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltipData: PropTypes.shape({}).isRequired,
};